import React from 'react';

import PropTypes from 'prop-types';

import theme from 'ui/theme';

import { colorOpacity } from 'utils/common';

import Icon from '../Icon';
import { CircleIconContainer } from './style';

const CircleIcon = ({
  circleSize,
  icon,
  iconSize,
  iconColor,
  specifiedColor
}) => (
  <CircleIconContainer
    size={circleSize}
    color={specifiedColor || colorOpacity(iconColor, '20%')}
  >
    <Icon type={icon} size={iconSize} color={iconColor} />
  </CircleIconContainer>
);

CircleIcon.defaultProps = {
  circleSize: '32px',
  iconColor: theme().colors.pink.one,
  iconSize: '24px'
};

CircleIcon.propTypes = {
  circleSize: PropTypes.string,
  icon: PropTypes.string,
  iconSize: PropTypes.string,
  iconColor: PropTypes.string,
  specifiedColor: PropTypes.string
};

export default CircleIcon;
